

const NotAuthorized = () => {
  return (
    <div>You are not authorized to view this page</div>
  )
}

export default NotAuthorized